import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabsPage } from './tabs.page';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'home',
        loadChildren: () => import('../home/home.module').then(m => m.HomePageModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('../notification/notification.module').then(m => m.NotificationPageModule)
      },
      {
        path: 'pregnant-mother',
        loadChildren: () => import('../pregnant-mother/pregnant-mother.module').then(m => m.PregnantMotherPageModule)
      },
      {
        path: 'medication',
        loadChildren: () => import('../medication/medication.module').then(m => m.MedicationPageModule)
      },
      {
        path: 'health-tips',
        loadChildren: () => import('../health-tips/health-tips.module').then(m => m.HealthTipsPageModule)
      },
      {
        path: 'pregmother-prescription',
        loadChildren: () => import('../pregmother-prescription/pregmother-prescription.module').then(m => m.PregmotherPrescriptionPageModule)
      },
      {
        path: 'camera',
        loadChildren: () => import('../camera/camera.module').then(m => m.CameraPageModule)
      },
      {
        path: 'gps',
        loadChildren: () => import('../gps/gps.module').then(m => m.GpsPageModule)
      },
      {
        path: 'appointments',
        loadChildren: () => import('../appointments/appointments.module').then(m => m.AppointmentsPageModule)
      },
      {
        path: 'report',
        loadChildren: () => import('../report/report.module').then(m => m.ReportPageModule)
      },
      {
        path: 'speciality',
        loadChildren: () => import('../speciality/speciality.module').then(m => m.SpecialityPageModule)
      },
      {
        path: 'doctors-list',
        loadChildren: () => import('../doctors-list/doctors-list.module').then(m => m.DoctorsListPageModule)
      },
      {
        path: 'doc-appointment',
        loadChildren: () => import('../doc-appointment/doc-appointment.module').then(m => m.DocAppointmentPageModule)
      },
      {
        path: 'booking-conf',
        loadChildren: () => import('../booking-conf/booking-conf.module').then(m => m.BookingConfPageModule)
      },
      {
        path: 'physio-doctors-list',
        loadChildren: () => import('../physio-doctors-list/physio-doctors-list.module').then(m => m.PhysioDoctorsListPageModule)
      },
      {
        path: 'physio-doc-appointment',
        loadChildren: () => import('../physio-doc-appointment/physio-doc-appointment.module').then(m => m.PhysioDocAppointmentPageModule)
      },
      {
        path: 'physio-booking-conf',
        loadChildren: () => import('../physio-booking-conf/physio-booking-conf.module').then(m => m.PhysioBookingConfPageModule)
      },
      {
        path: 'physio-appointment',
        loadChildren: () => import('../physio-appointment/physio-appointment.module').then(m => m.PhysioAppointmentPageModule)
      },
      {
        path: 'profile',
        loadChildren: () => import('../profile/profile.module').then(m => m.ProfilePageModule)
      },
      {
        path: 'prescription',
        loadChildren: () => import('../prescription/prescription.module').then(m => m.PrescriptionPageModule)
      },
      {
        path: 'nursing',
        loadChildren: () => import('../nursing/nursing.module').then(m => m.NursingPageModule)
      },
      {
        path: 'nurse-booking',
        loadChildren: () => import('../nurse-booking/nurse-booking.module').then(m => m.NurseBookingPageModule)
      },
      {
        path: 'booking-room',
        loadChildren: () => import('../booking-room/booking-room.module').then(m => m.BookingRoomPageModule)
      },
      {
        path: 'chat',
        loadChildren: () => import('../chat/chat.module').then(m => m.ChatPageModule)
      },
      {
        path: 'tab2',
        loadChildren: () => import('../tab2/tab2.module').then(m => m.Tab2PageModule)
      },
      {
        path: 'tab3',
        loadChildren: () => import('../tab3/tab3.module').then(m => m.Tab3PageModule)
      },
      {
        path: 'tab4',
        loadChildren: () => import('../tab4/tab4.module').then(m => m.Tab4PageModule)
      },
      {
        path: 'lab',
        loadChildren: () => import('../lab/lab.module').then(m => m.LabPageModule)
      },
      {
        path: 'code-scanner',
        loadChildren: () => import('../code-scanner/code-scanner.module').then(m => m.CodeScannerPageModule)
      },
      // {
      //   path: 'payment',
      //   loadChildren: () => import('../payment/payment.module').then(m =>m.PaymentPageModule)
      // },
      {
        path: 'dietmeal',
        loadChildren: () => import('../dietmeal/dietmeal.module').then(m => m.DietmealPageModule)
      },
      {
        path: 'trainingCenter',
        loadChildren: () => import('../training-center/training-center.module').then(m => m.TrainingCenterPageModule)
      },
      {
        path: 'shopping',
        loadChildren: () => import('../shopping/shopping.module').then(m => m.ShoppingPageModule)
      },
      {
        path: 'trainer',
        loadChildren: () => import('../trainer/trainer.module').then(m => m.TrainerPageModule)
      },
      {
        path: 'physiotherapy',
        loadChildren: () => import('../physiotherapy/physiotherapy.module').then(m => m.PhysiotherapyPageModule)
      },
      {
        path: 'newphysiotherapy',
        loadChildren: () => import('../newphysiotherapy/newphysiotherapy.module').then(m => m.NewphysiotherapyPageModule)
      },
      {
        path: 'commonNotification',
        loadChildren: () => import('../common-notification/common-notification.module').then(m => m.CommonNotificationPageModule)
      },
      {
        path: 'chats',
        loadChildren: () => import("../chats/chats.module").then(m => m.ChatsPageModule)

      },
      {
        path: 'vaccination-schedule',
        loadChildren: () => import('../vaccination-schedule/vaccination-schedule.module').then(m => m.VaccinationSchedulePageModule)
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/tabs/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class TabsPageRoutingModule { }
